module.exports = __webpack_public_path__ + "static/img/servicio2.481dfe1d.jpeg";